import sendxAPI from '../xAPI'

const initialState = {
  display: false,
  type: null,
  size: 'sm',
  connect: -1,
  shown: false,
}
let show;
let display;

export default (state = initialState, action) => {
    switch (action.type) {

        case 'SET_MODAL':
            return {...state, ...action.payload}

        case 'SHOW_MODAL':

            // xAPI statement
            sendxAPI({
              // Type of statement
              verb: {
                description: "focused",
                address: "https://w3id.org/xapi/dod-isd/verbs/focused"
              },
              // Where the action occured
              context: state.type + " modal display",
              // Result of the action
              result: {
                success: true,
                response: action.payload
              }
            })

            show = state.shown;
            display = state.type === "PROTOCOL_READ"? !show : action.payload.display;

            if(state.type === "PROTOCOL_READ"){
              show = true;
            }

            return {...state, ...{ display: display, shown: show}}

        case "UNDO":
            //Payload = {lastState}

            if (action.payload.lastState !== null) {
              return action.payload.lastState.modal;
            } else {
              return state;
            }


        default:
            return state
    }
};
